import { VAULT } from "./vaultStats";
export const LANDING_FAQ = [
  {
    q: "What happens after I click unlock?",
    a: "Create your account, confirm immediate digital access, then complete the secure Stripe checkout. Your vault opens as soon as payment is confirmed.",
  },
  {
    q: "Do I need a separate OpenAI, Claude or Gemini account?",
    a: "No. Lifetime members can run prompts inside Stag Vault on ChatGPT (GPT-5.2), Claude or Gemini — switch models per run. You can also copy any prompt into ChatGPT, Claude or Gemini if you prefer your own account.",
  },
  {
    q: "Will this work for my skills or niche?",
    a: `The ${VAULT.tracks} tracks cover content, commerce, digital products and productised services. If you are unsure, the free 60-second quiz recommends a practical starting track based on your time, skills and budget.`,
  },
  {
    q: "What is included in the £25 lifetime price?",
    a: `All ${VAULT.tracks} tracks, all ${VAULT.promptsFmt} prompts, unlimited in-app AI runs on ChatGPT, Claude or Gemini, the template library and every future track drop. It is one payment, not a subscription.`,
  },
  {
    q: "What if it is not right for me?",
    a: "Every purchase has a 14-day no-questions refund. Contact Stag Vault within 14 days and the team will arrange it without fuss or arguments.",
  },
];

export const LANDING_TRACKS = [
  { order: 1, slug: "ebook-writing", name: "E-book Writing", tagline: "Turn one useful idea into a packaged digital book and launch copy.", image_icon: "ebook-writing.jpg", prompt_count: 12, outcome: "A sellable KDP-ready book" },
  { order: 3, slug: "youtube-automation", name: "YouTube Automation", tagline: "Build a repeatable faceless channel workflow from research to upload.", image_icon: "social-media.jpg", prompt_count: 11, outcome: "A complete video pipeline" },
  { order: 63, slug: "estate-sale-probate-cataloguer", name: "Estate-Sale Cataloguer", tagline: "Package a photo-cataloguing service for solicitors and families.", image_icon: "estate-sale-probate-cataloguer.webp", prompt_count: 10, outcome: "A £299–£599 service offer" },
  { order: 66, slug: "wedding-speech-vows-studio", name: "Wedding Speech Studio", tagline: "Create a structured intake and delivery service for speeches and vows.", image_icon: "wedding-speech-vows-studio.webp", prompt_count: 10, outcome: "A £49–£299 service" },
];

export const LIFETIME_BENEFITS = [
  `All ${VAULT.tracks} income playbooks and ${VAULT.promptsFmt} prompts`,
  "Unlimited AI runs inside the vault — ChatGPT, Claude or Gemini",
  "Content, Commerce and Consulting bundles included",
  "Every future track drop included forever",
  "14-day no-questions refund",
];

export const DAY_ONE_UNLOCKS = [
  ["Choose a credible route", `Filter ${VAULT.tracks} tracks by time, skill and starting budget.`],
  ["Follow prompts in order", "Move from niche and offer to delivery and launch."],
  ["Run prompts in the app", "Use ChatGPT, Claude or Gemini without adding your own API key."],
  ["Keep what you build", "Copy, save and export the work behind your new offer."],
];

export const COMPARISON_ROWS = [
  ["Direction", "One-off prompts", "A sequenced route from idea to shipped asset"],
  ["Organisation", "Scattered tabs and saved posts", "One searchable vault organised by income model"],
  ["Output", "A draft with no next step", "Prompts for the offer, asset, launch and follow-up"],
];